(() => {
  const selector = ".shopify-section--main-collection .editorial-card:not(.showroom-card)";
  const observedCards = new WeakSet();

  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll(selector).forEach((card) => card.classList.add("is-in-view"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle("is-in-view", entry.isIntersecting);
      });
    },
    {
      rootMargin: "-12% 0px -18% 0px",
      threshold: 0.28,
    }
  );

  const observeCards = (root = document) => {
    const cards = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];

    cards.forEach((card) => {
      if (observedCards.has(card)) return;
      observedCards.add(card);
      observer.observe(card);
    });
  };

  observeCards();

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) observeCards(node);
      });
    });
  });

  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
